module.exports = __webpack_public_path__ + "static/media/close-24px.b840e171.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/close-24px.svg
// module id = 717
// module chunks = 0